import React from 'react';
import FaUser from '@assets/icons/fa-user';
import Trophy from '@assets/icons/trophy';
import ShieldHeartRegular from '@assets/icons/shield-heart-regular';
import { FEATURE_BADGES } from '@utils/constants/menu.constants';
import CreditCard from '@assets/icons/credit-card';
import LockRegular from '@assets/icons/lock-regular';
import Headset from '@assets/icons/headset';
import Handshake from '@assets/icons/handshake';
import ShieldKeyhole from '@assets/icons/shield-keyhole';
import { SVGProps } from 'react';
import EnvelopeOpenText from '@assets/icons/envelope-open-text';

export interface AccountMenuItem {
  type: string;
  key: string;
  label: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  url: string;
  externalLink: boolean;
  featureId?: number;
  hide?: boolean;
  domId?: string;
}

export interface AccountMenuGroupItem {
  type: string;
  key: string;
  label: string;
  child: AccountMenuItem[];
}

export function useAccountMenuList() {
  const AccountMenuList: AccountMenuGroupItem[] = [
    {
      type: 'group',
      key: 'group-profile',
      label: 'Profile',
      child: [
        {
          type: 'menu',
          key: 'menu-profile',
          label: 'My Profile',
          icon: FaUser,
          url: '/profile',
          externalLink: false,
        },
      ],
    },
    {
      type: 'group',
      key: 'group-achievement',
      label: 'Achievement',
      child: [
        {
          type: 'menu',
          key: 'menu-exam-result',
          label: 'Exam Results',
          icon: EnvelopeOpenText,
          url: '/exam-result',
          externalLink: false,
          hide: false,
        },
        {
          type: 'menu',
          key: 'menu-leaderboard',
          label: 'Leaderboard',
          icon: Trophy,
          url: '/leaderboard',
          hide: false,
          domId: 'leaderboard-navigation',
          externalLink: false,
        },
        {
          type: 'menu',
          key: 'menu-badges',
          label: 'Badges',
          icon: ShieldHeartRegular,
          url: '/badges',
          featureId: FEATURE_BADGES,
          externalLink: false,
        },
      ],
    },
    {
      type: 'group',
      key: 'group-setting',
      label: 'Settings',
      child: [
        {
          type: 'subscription',
          key: 'menu-account-subscription',
          label: 'Subscription',
          icon: () => <CreditCard className={'h-4'} />,
          url: '/subscription',
          externalLink: false,
        },
        {
          type: 'menu',
          key: 'menu-account-setting',
          label: 'Account Settings',
          icon: LockRegular,
          url: '/account-settings',
          externalLink: false,
        },
      ],
    },
    {
      type: 'group',
      key: 'group-support',
      label: 'Support',
      child: [
        {
          type: 'menu',
          key: 'menu-help',
          label: 'Help Centre',
          icon: () => <Headset className={'h-4'} />,
          url: 'https://geniebook.atlassian.net/servicedesk/customer/portal/1',
          externalLink: true,
        },
        {
          type: 'menu',
          key: 'menu-tos',
          label: 'Terms of Service',
          icon: () => <Handshake className={'h-4'} />,
          url: 'https://geniebook.com/terms',
          externalLink: true,
        },
        {
          type: 'menu',
          key: 'menu-pp',
          label: 'Privacy Policy',
          icon: () => <ShieldKeyhole className={'h-4'} />,
          url: 'https://geniebook.com/policies/privacy',
          externalLink: true,
        },
      ],
    },
  ];

  return AccountMenuList;
}
